import { render, staticRenderFns } from "./passwordLogin.vue?vue&type=template&id=5d73c5cb&scoped=true"
import script from "./passwordLogin.vue?vue&type=script&lang=js"
export * from "./passwordLogin.vue?vue&type=script&lang=js"
import style0 from "./passwordLogin.vue?vue&type=style&index=0&id=5d73c5cb&prod&lang=scss&scoped=true"
import style1 from "./passwordLogin.vue?vue&type=style&index=1&id=5d73c5cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73c5cb",
  null
  
)

export default component.exports